import { authenticateLms } from '../../../modules/lms/api/lmsAuth.client';
import type { LoginResponse } from '../../../modules/platform/types';
import type { User } from '../../../modules/platform/types';
import {
  resolveLmsLaunchTargetPath,
} from '../../../utils/lmsLaunch';
import { getLmsLaunchErrorPresentation } from '../../../utils/lmsLaunchErrors';
import type { LmsLaunchErrorPresentation } from '../../../utils/lmsLaunchErrors';

export type LaunchFlowResult =
  | { ok: true; user: User; targetPath: string }
  | { ok: false; presentation: LmsLaunchErrorPresentation };

/**
 * Shared LMS launch: POST /auth/authenticate via gateway only.
 */
export async function runLmsLaunchFlow(
  assertionJwt: string,
  options: {
    returnUrl?: string | null;
    completeLmsSession: (response: LoginResponse) => Promise<User>;
  }
): Promise<LaunchFlowResult> {
  const debugLms = import.meta.env.DEV;
  try {
    if (debugLms) {
      console.debug('[LMS Launch] authenticate started');
    }
    const response = await authenticateLms({ assertion_jwt: assertionJwt });
    const sessionUser = await options.completeLmsSession(response as LoginResponse);
    const targetPath = resolveLmsLaunchTargetPath(sessionUser, options.returnUrl ?? null);
    if (debugLms) {
      console.debug('[LMS Launch] authenticate success');
      console.debug('[LMS Launch] user role', sessionUser.roles, sessionUser.memberships?.[0]?.role);
      console.debug('[LMS Launch] target path', targetPath);
    }
    return { ok: true, user: sessionUser, targetPath };
  } catch (err) {
    return { ok: false, presentation: getLmsLaunchErrorPresentation(err) };
  }
}
